import { client } from '../client';
import { convertValues } from '~/util';

export interface AdminTransfer {
  createdAt: string;
  completedAt?: string | null;
  adminTransferId: string;
  bankAccountId: string;
  type: 'credit' | 'debit';
  currency: string;
  amount: number;
  description: string;
  detailsType?: string | null;
  details?: Record<string, unknown> | null;
}

export class AdminRepository {
  static async get(request: GetRequestType) {
    return client
      .get<unknown, AdminTransfer>(`/transfers/admin/${request.id}`)
      .then((response) => convertValues<AdminTransfer>(response));
  }
}
